import { z } from "zod";

// 基础文章数据结构
export const articleSchema = z.object({
  id: z.string(),
  title: z.string(),
  slug: z.string(),
  content: z.string(),
  summary: z.string().nullable(),
  tags: z.array(z.string()).optional(),
  published: z.boolean().default(true),
  createdAt: z.date(),
  updatedAt: z.date(),
});

// 创建文章的请求体
export const createArticleSchema = z.object({
  title: z.string().min(1, "标题不能为空"),
  content: z.string().min(1, "内容不能为空"),
  slug: z.string().optional(),
  summary: z.string().optional(),
  tags: z.array(z.string()).optional(),
  published: z.boolean().optional(),
});

// 更新文章的请求体
export const updateArticleSchema = createArticleSchema.partial();

// 类型导出
export type Article = z.infer<typeof articleSchema>;
export type CreateArticleDTO = z.infer<typeof createArticleSchema>;
export type UpdateArticleDTO = z.infer<typeof updateArticleSchema>;

// 响应类型
export type ArticleResponse = {
  data: Article;
};

export type ArticlesResponse = {
  data: Article[];
  total: number;
  page: number;
  pageSize: number;
};
